import React from "react";

export default function BuildingPage() {
    return (
        <div style={styles.container}>
            <div style={styles.box}>
                <h1 style={styles.title}>🚧 Em Desenvolvimento 🚧</h1>
                <p style={styles.message}>
                    Olá, esta funcionalidade está em desenvolvimento! <br />
                    Em breve estará disponível.
                </p>
            </div>
        </div>
    );
}

const styles = {
    container: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    box: {
        backgroundColor: "#fff3cd",
        border: "1px solid #ffeeba",
        borderRadius: "10px",
        padding: "40px",
        textAlign: "center",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    },
    title: {
        margin: 0,
        color: "#856404",
    },
    message: {
        marginTop: "10px",
        color: "#856404",
        fontSize: "18px",
    },
};
